/*
  The light and dark switch in the footer. With no choice stored the page
  follows the system (color-scheme in tokens.css does that without this file).
  A choice is stored only while it differs from the system, so switching back
  to the system's own mode means following the system again. Reads and writes
  localStorage 'capra:mode', read before the first paint by layout/theme.liquid.
*/

const root = document.documentElement;
const system = matchMedia('(prefers-color-scheme: dark)');
const KEY = 'capra:mode';

const systemMode = () => (system.matches ? 'dark' : 'light');
const currentMode = () => root.dataset.mode || systemMode();

// The browser bar takes the page colour, whatever the season and mode.
function paintBar() {
  let meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.append(meta);
  }
  meta.content = getComputedStyle(document.body).backgroundColor;
}

class CapraMode extends HTMLElement {
  connectedCallback() {
    // Without light-dark() the palette has no dark version to switch to.
    if (!CSS.supports('color', 'light-dark(#000, #fff)')) return;
    this.button = this.querySelector('button');
    this.button.addEventListener('click', () => this.choose(currentMode() === 'dark' ? 'light' : 'dark'));
    system.addEventListener('change', () => this.sync());
    this.hidden = false;
    this.sync();
  }

  choose(mode) {
    const followSystem = mode === systemMode();
    if (followSystem) delete root.dataset.mode;
    else root.dataset.mode = mode;
    try {
      if (followSystem) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, mode);
    } catch (e) {}
    this.sync();
  }

  sync() {
    this.button.setAttribute('aria-checked', String(currentMode() === 'dark'));
    paintBar();
  }
}

customElements.define('capra-mode', CapraMode);
